(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    const cardGalleries = document.querySelectorAll(".card-gallery");

    cardGalleries.forEach((gallery) => {
      gallery.style.cursor = "pointer";

      gallery.addEventListener("click", function (event) {
        if (!event.target) return;

        const clickedElement = event.target;
        const isInteractive = clickedElement.closest(
          'button, a, input, label, select, textarea, slideshow-arrows, [role="button"], [tabindex="0"]'
        );

        if (isInteractive) {
          return;
        }

        const productCard = gallery.closest("product-card");
        if (!productCard) return;

        const productLink = productCard.querySelector(
          'a[ref="productCardLink"]'
        );
        if (productLink && productLink.href) {
          event.preventDefault();
          event.stopPropagation();

          window.location.href = productLink.href;
        }
      });
    });
  }
})();
